export default "/_next/static/chunks/fonts/WorkSans-Light-latin-ffdf824fff691aaecbf82fdf3c0c3fb8.woff2";